import {TaskTypeActionRequired} from "../../../gd/task-type/task-type"

import {TaskViewLayout} from "../@conts";
import {TaskTypeSettingsVersion} from "./@const";

export default class TaskTypeSettings {

    public actionRequired       : TaskTypeActionRequired
    public isGeneric            : boolean       = false
    public requiredFields       : string[]
    public hiddenFields         : string[]      // this are disabled SystemFields
    public checklist            : any
    public layout?              : TaskViewLayout
    public version              : TaskTypeSettingsVersion   // For implement any order sort

    constructor(settingsData: any) {
        this.actionRequired          = (!settingsData ||
            ![
                TaskTypeActionRequired.ALLOWED,
                TaskTypeActionRequired.DENIED_ON_REPLY
            ].includes(settingsData.actionRequired)) ?
            TaskTypeActionRequired.ALLOWED
            :
            settingsData.actionRequired

        this.isGeneric      = _.get(settingsData,'isGeneric',false)
        this.requiredFields = _.get(settingsData,'requiredFields',[])
        this.hiddenFields   = _.get(settingsData,'hiddenFields',[])
        this.checklist      = _.get(settingsData,'checklist',null)
        this.layout         = _.get(settingsData,'layout',undefined)
        this.version        = _.get(settingsData,'version', TaskTypeSettingsVersion.V1)
    }

    checkSystemFieldDisabled(fieldId:string) {
        return this.hiddenFields.includes(fieldId)
    }

    get isLayoutSet():boolean {
        // Figure out if layout set to use it or user defined instead
        return !!this.layout
    }

    get isActionRequiredEnabled() {
        return !this.checkSystemFieldDisabled('actionRequiredUserId')
    }

    toJSON() {
        return {
            actionRequired      : this.actionRequired,
            isGeneric           : this.isGeneric,
            requiredFields      : this.requiredFields,
            hiddenFields        : this.hiddenFields,
            checklist           : this.checklist,
            layout              : this.layout,
            version             : this.version
        }
    }
}
